import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ReportRecordDataProvider from '/component/partial/reportCard/ReportRecordDataProvider';
import {
  addCoachToWatchlist,
  removeCoachFromWatchlist,
} from '/redux/action/myTeams.action';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {downlineCoachIds} from '/redux/selector/watchList.selector';
import {withProps} from '/util/selector.util';

import CoachReportPopover from './CoachReportPopover';

export default connect(
  createStructuredSelector({
    userId,
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestAchievedRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    downlineCoachIds,
  }),
  dispatch => ({
    addCoachToWatchlist: (downlineCoachId: string) =>
      dispatch<any>(addCoachToWatchlist({downlineCoachId})),
    removeCoachFromWatchlist: (downlineCoachId: string) =>
      dispatch<any>(removeCoachFromWatchlist({downlineCoachId})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    dataRenderer: CoachReportPopover,
    dataRendererProps: {
      ...ownProps,
      lastPaidRank: stateProps.lastPaidRank,
      highestAchievedRank: stateProps.highestAchievedRank,
      coachCurrentRank: stateProps.coachCurrentRank,
      userId: stateProps.userId,
      downlineCoachIds: stateProps.downlineCoachIds, // <-- use stateProps value
      addCoachToWatchlist: dispatchProps.addCoachToWatchlist,
      removeCoachFromWatchlist: dispatchProps.removeCoachFromWatchlist,
    },
  }),
)(ReportRecordDataProvider);
